import { API } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { Account, CheckAccountStateQuery } from '../../../API';
import { checkAccountState } from '../../../graphql/queries';
import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { selectPlayer, updateAccount } from '../../../features/player/playerSlice';
import { RootState } from '../../../app/store';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { selectTheme } from '../../../features/theme/themeSlice';

type ProfileAccountBalanceProps = {
	vertical?: boolean;
};

const ProfileAccountBalance: React.FC<ProfileAccountBalanceProps> = ({ vertical }) => {
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const player = useAppSelector(selectPlayer);
	const theme = useAppSelector(selectTheme);
	const dispatch = useDispatch();
	useEffect(() => {
		(async () => {
			const result: GraphQLResult<CheckAccountStateQuery> = (await API.graphql({
				query: checkAccountState,
				authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
			})) as GraphQLResult<CheckAccountStateQuery>;

			dispatch(updateAccount(result.data.checkAccountState));
		})();
	}, []);
	return player.account ? (
		<div className="d-flex f-row profile-account-balance">
			<div className="d-flex f-column">
				<p>
					<FormattedMessage id="balance" />
				</p>
				<div className={`valute valute-${theme.language}`}>
					<FormattedNumber
						value={
							player.account.deposit +
							player.account.winnings -
							player.account.expenses -
							player.account.pickedUp
						}
						style="currency"
						currency={player.account.valute}
					/>
				</div>
			</div>
			<div className="d-flex f-column">
				<p>Bonus</p>
				<div className={`valute valute-${theme.language}`}>
					<FormattedNumber value={player.account.bonus} style="currency" currency={player.account.valute} />
				</div>
			</div>
		</div>
	) : (
		<div></div>
	);
};

export default ProfileAccountBalance;
